import type { RadarBubble } from '@/services/api/teacher'

/**
 * Liest den highlight-Parameter aus der URL
 */
export function getHighlightParam(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('highlight')
}

/**
 * Entfernt den highlight-Parameter
 */
export function clearHighlightParam(): void {
  const url = new URL(window.location.href)
  url.searchParams.delete('highlight')
  window.history.replaceState({}, '', url.toString())
}

/**
 * Liest den focus-Parameter aus der URL (Magic-Link-Ankunft: persistentes Highlight).
 */
export function getFocusParam(): boolean {
  const params = new URLSearchParams(window.location.search)
  return params.get('focus') === '1'
}

/**
 * Ermittelt die Ziel-Route basierend auf Bubble-Typ
 */
export function getTargetRoute(bubble: RadarBubble): string {
  if (bubble.bubble_type === 'incoming') {
    return '/teacher/incoming-requests'
  }
  return '/teacher/requests'
}

/**
 * Extrahiert die Request-ID aus einer Bubble
 */
export function getRequestIdFromBubble(bubble: RadarBubble): string {
  return bubble.request_id
}
